import { render, staticRenderFns } from "./activityNewAssignments.html?vue&type=template&id=0ca5a689&scoped=true&external"
import script from "./activityNewAssignments.vue?vue&type=script&lang=js"
export * from "./activityNewAssignments.vue?vue&type=script&lang=js"
import style0 from "./activityNewAssignments.css?vue&type=style&index=0&id=0ca5a689&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca5a689",
  null
  
)

export default component.exports